export function average(values: number[]) {
	return values.reduce((sum, it) => sum + it, 0) / (values.length || 1)
}
